import jsonLogic from "json-logic-js";
export default function(value, expr){

    if(value == null){
        return false;
    }
    if(!Array.isArray(value)){
        value = [value];
    }
    let rule = JSON.parse(expr);
    let resp = true;
    for(let model of value){
        resp = jsonLogic.apply(rule, model);
        if(!resp){
            break;
        }
    }
    return resp;
}
